import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios, postRRAxios } from "./axiosActions";
import _ from "lodash";
import { fetchGPTUsageData } from "./logs";
import AppConfig from "../../appConfig";
import moment from "moment";

export const initialState = {
  loading: false,
  hasErrors: false,
  companyTopics: [],
  standardTopics: [],
  topics: {},
  errorMessage: "",
  loadingSaveTopics: false,
  errorSaveTopics: false,
  loadingSaveStandardTopics: false,
  errorSaveStandardTopics: false,
};
const getTopicsFromLocalStorage = (userId) => {
  const key = userId + "_topics";
  let userStorage = localStorage.getItem(key) ? localStorage.getItem(key) : {};
  return userStorage && typeof userStorage !== "object"
    ? JSON.parse(userStorage)
    : {};
};
const setTopicsToLocalStorage = (payload) => {
  const key = payload?.userId + "_topics";
  let userStorage = localStorage.getItem(key)
    ? JSON.parse(localStorage.getItem(key))
    : {};
  userStorage[payload.key] = {
    lastModified: moment().format("YYYY-MM-DD HH:mm:ss"),
    output: payload.data,
  };
  localStorage.setItem(key, JSON.stringify(userStorage));
};
const topicsSlice = createSlice({
  name: "topics",
  initialState,
  reducers: {
    getTopics: (state) => {
      state.loading = true;
    },
    getTopicsSuccess: (state, { payload }) => {
      state[payload?.objKey] = payload?.data ?? [];
      state.loading = false;
      state.hasErrors = false;
    },
    getTopicsFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    saveTopics: (state) => {
      state.loadingSaveTopics = true;
    },
    saveTopicsSuccess: (state, { payload }) => {
      state.loadingSaveTopics = false;
      state.errorSaveTopics = false;
    },
    saveTopicsFailure: (state) => {
      state.loadingSaveTopics = false;
      state.errorSaveTopics = true;
    },
    generateTopicsData: (state) => {
      state.loading = true;
    },
    generateTopicsDataSuccess: (state, { payload }) => {
      let topics =
        _.cloneDeep(_.isEmpty(state.topics) ? null : state.topics) ?? {};

      topics[payload.key] = {
        lastModified: moment().format("YYYY-MM-DD HH:mm:ss"),
        output: payload.data?.responseContent,
        errorMessage:
          payload.data?.statusMessage === "Success"
            ? null
            : payload.data?.statusMessage,
      };
      state.topics = topics;
      state.loading = false;
      state.hasErrors = false;
    },
    generateTopicsDataFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    executePromptMultiple: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    setPreGeneratedTopics: (state, { payload }) => {
      const topics = getTopicsFromLocalStorage(payload);
      state.topics = topics;
      state.loading = false;
      state.hasErrors = false;
    },
    errorRemove: (state, { payload }) => {
      let topics = state.topics;
      if (topics[payload]) {
        topics[payload].errorMessage = null;
      }

      state.topics = topics;
      state.loading = false;
      state.hasErrors = false;
    },
  },
});

export const {
  getTopics,
  getTopicsSuccess,
  getTopicsFailure,
  generateTopicsData,
  generateTopicsDataSuccess,
  generateTopicsDataFailure,
  saveTopics,
  saveTopicsSuccess,
  saveTopicsFailure,
  executePromptMultiple,
  setPreGeneratedTopics,
  errorRemove,
} = topicsSlice.actions;
export const topicsSelector = (state) => state.topics;
export default topicsSlice.reducer;
export function getTopicsData(companyId) {
  return async (dispatch) => {
    dispatch(getTopics());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Topics/GetCompanyTopics/" +
          (companyId ? "?companyId=" + companyId : ""),
        { params: params }
      );
      dispatch(getTopicsSuccess({ data, objKey: "companyTopics" }));
    } catch (error) {
      dispatch(getTopicsFailure());
    }
  };
}
export function getStandardTopicsData(companyType) {
  return async (dispatch) => {
    dispatch(getTopics());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Topics/GetStandardTopics/" +
          (companyType ? "?companyType=" + companyType : ""),
        { params: params }
      );
      dispatch(getTopicsSuccess({ data, objKey: "standardTopics" }));
    } catch (error) {
      dispatch(getTopicsFailure());
    }
  };
}
export function generateTopics(params, key, companyId) {
  return async (dispatch) => {
    dispatch(generateTopicsData());

    try {
      // const params = { callTime: new Date() };
      const data = await postAxios("api/Topics/GenerateTopics", {
        params: params,
      });

      await dispatch(generateTopicsDataSuccess({ data, key: key }));
      if (companyId) {
        dispatch(
          fetchGPTUsageData(
            companyId,
            localStorage.getItem("userId")
              ? localStorage.getItem("userId")
              : AppConfig.env("userId"),
            {}
          )
        );
      }
    } catch (error) {
      dispatch(generateTopicsDataFailure());
    }
  };
}
export const executePromptMul = (data, key, userId, companyId) => {
  return async (dispatch) => {
    dispatch(executePromptMultiple(data));
    try {
      const response = await postAxios("api/OpenAi/ExecutePromptMultiple", {
        params: data,
      });
      const obj = { data: response?.responseContent, key: key, userId: userId };
      await dispatch(generateTopicsDataSuccess({ data: response, key: key }));
      if (companyId) {
        dispatch(
          fetchGPTUsageData(
            companyId,
            localStorage.getItem("userId")
              ? localStorage.getItem("userId")
              : AppConfig.env("userId"),
            data?.businessType ? { ["BusinessType"]: data?.businessType } : {}
          )
        );
      }
      setTopicsToLocalStorage(obj);
    } catch (error) {
      dispatch(generateTopicsDataFailure());
    }
  };
};
export function saveTopicData(params, companyId) {
  return async (dispatch) => {
    dispatch(saveTopics());

    try {
      // const params = { callTime: new Date() };
      const data = await postAxios("api/Topics/SaveTopics", { params: params });
      dispatch(saveTopicsSuccess({ data, companyId }));
      dispatch(getTopicsData(companyId));
    } catch (error) {
      dispatch(saveTopicsFailure());
    }
  };
}
export function saveStandardTopicData(params, companyType) {
  return async (dispatch) => {
    dispatch(saveTopics());

    try {
      // const params = { callTime: new Date() };
      const data = await postAxios("api/Topics/SaveStandardTopics", {
        params: params,
      });
      dispatch(saveTopicsSuccess({ data, companyType }));
      dispatch(getStandardTopicsData(companyType));
    } catch (error) {
      dispatch(saveTopicsFailure());
    }
  };
}
